export const WATCHBLOCK_TOKEN = 'WATCHBLOCK_TOKEN';
export const WATCHBLOCK_REFRESH_TOKEN = 'WATCHBLOCK_REFRESH_TOKEN';
